import { ChangeEventHandler, FC } from "react";
import { MEDIUM_ICON_SIZE_STYLES } from "../../ui/styles";

type CheckboxProps = {
  isChecked: boolean;
  labelText: string;
  action: ChangeEventHandler<HTMLInputElement>;
  idDisabled?: boolean;
};

export const Checkbox: FC<React.PropsWithChildren<CheckboxProps>> = ({
  isChecked,
  labelText,
  action,
  idDisabled = false,
}) => {
  return (
    <label className="my-auto flex cursor-pointer text-sm dark:text-stone-300">
      <input
        type="checkbox"
        className="hidden"
        checked={isChecked}
        onChange={action}
        disabled={idDisabled}
      />
      <span
        className={`relative left-0 top-0 rounded border border-stone-200 bg-stone-50 fill-stone-500 dark:border-stone-600 dark:fill-stone-400 ${MEDIUM_ICON_SIZE_STYLES}`}
      >
        {isChecked && (
          <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z" />
          </svg>
        )}
      </span>

      <span className="ml-1.5">{labelText}</span>
    </label>
  );
};
